// Sample RealPay data for the UI-first build pass. Shapes are copied
// verbatim from real live responses captured against RealPay's own API
// (maintain/clients, maintain/contracts, maintain/instalments) during the
// CoverLink installment-extension work — only the values are fictional.
// Swap this module out for the real GET /api/realpay/... call once the
// payment-request endpoint exists.
export const mockClient = {
  ClientNumber: 'MC-COV4895',
  ClientName: 'Naledi Kgosi',
  IDType: 'I',
  IDNumber: '846811126',
  BankCode: 12,
  BranchCode: 283767,
  AccountType: '1', // 1 = Cheque, 2 = Savings
  AccountNumber: '62868020802',
  AccountHolderName: 'Naledi Kgosi',
  BankName: 'First National Bank'
}

export const mockContract = {
  ContractSequence: 1053432320,
  ClientNumber: 'MC-COV4895',
  ContractNumber: 'MC-COV4895',
  CTCPercentage: 100,
  InstalmentStartDate: '2026-08-31 14:00',
  TrackingCode: 'B4',
  NumberOfInstalments: 24,
  FirstCollectionDate: '2026-07-31 14:00',
  FirstCollectionAmount: 135,
  FrequencyCode: 'MNTH',
  CollectionDay: 99, // 99 = last day of month
  SubscriptionYN: 'N',
  ContractStatus: 'A'
}

// A realistic spread across all 5 statuses: one collected, one missed, one
// retrying, one mid-processing, the rest scheduled into the future.
export const mockInstalments = [
  {
    ClientNumber: 'MC-COV4895',
    ContractNumber: 'MC-COV4895',
    ContractSequence: 1053432320,
    InstalmentSequence: 1,
    InstalmentReferenceNumber: '10534323200001',
    InstalmentActionDate: '2026-07-31T14:00:00Z',
    TrackingCode: 'B4',
    InstalmentAmount: 135,
    CTCAmount: 0,
    InstalmentStatus: 'S',
    LastUpdateDate: '2026-07-31T14:21:23Z'
  },
  {
    ClientNumber: 'MC-COV4895',
    ContractNumber: 'MC-COV4895',
    ContractSequence: 1053432320,
    InstalmentSequence: 2,
    InstalmentReferenceNumber: '10534323200002',
    InstalmentActionDate: '2026-08-31T14:00:00Z',
    TrackingCode: 'B4',
    InstalmentAmount: 135,
    CTCAmount: 0,
    InstalmentStatus: 'I',
    LastUpdateDate: '2026-08-31T14:18:02Z'
  },
  {
    ClientNumber: 'MC-COV4895',
    ContractNumber: 'MC-COV4895',
    ContractSequence: 1053432320,
    InstalmentSequence: 3,
    InstalmentReferenceNumber: '10534323200003',
    InstalmentActionDate: '2026-09-30T14:00:00Z',
    TrackingCode: 'B4',
    InstalmentAmount: 135,
    CTCAmount: 0,
    InstalmentStatus: 'R',
    LastUpdateDate: '2026-09-30T15:02:11Z'
  },
  {
    ClientNumber: 'MC-COV4895',
    ContractNumber: 'MC-COV4895',
    ContractSequence: 1053432320,
    InstalmentSequence: 4,
    InstalmentReferenceNumber: '10534323200004',
    InstalmentActionDate: '2026-10-31T14:00:00Z',
    TrackingCode: 'B4',
    InstalmentAmount: 135,
    CTCAmount: 0,
    InstalmentStatus: 'W',
    LastUpdateDate: '2026-10-31T14:05:44Z'
  },
  {
    ClientNumber: 'MC-COV4895',
    ContractNumber: 'MC-COV4895',
    ContractSequence: 1053432320,
    InstalmentSequence: 5,
    InstalmentReferenceNumber: '10534323200005',
    InstalmentActionDate: '2026-11-30T14:00:00Z',
    TrackingCode: 'B4',
    InstalmentAmount: 135,
    CTCAmount: 0,
    InstalmentStatus: 'A',
    LastUpdateDate: '2026-07-03T11:49:57Z'
  },
  {
    ClientNumber: 'MC-COV4895',
    ContractNumber: 'MC-COV4895',
    ContractSequence: 1053432320,
    InstalmentSequence: 6,
    InstalmentReferenceNumber: '10534323200006',
    InstalmentActionDate: '2026-12-31T14:00:00Z',
    TrackingCode: 'B4',
    InstalmentAmount: 135,
    CTCAmount: 0,
    InstalmentStatus: 'A',
    LastUpdateDate: '2026-07-03T11:49:57Z'
  },
  {
    ClientNumber: 'MC-COV4895',
    ContractNumber: 'MC-COV4895',
    ContractSequence: 1053432320,
    InstalmentSequence: 7,
    InstalmentReferenceNumber: '10534323200007',
    InstalmentActionDate: '2027-01-31T14:00:00Z',
    TrackingCode: 'B4',
    InstalmentAmount: 135,
    CTCAmount: 0,
    InstalmentStatus: 'A',
    LastUpdateDate: '2026-07-03T11:49:57Z'
  },
  {
    ClientNumber: 'MC-COV4895',
    ContractNumber: 'MC-COV4895',
    ContractSequence: 1053432320,
    InstalmentSequence: 8,
    InstalmentReferenceNumber: '10534323200008',
    InstalmentActionDate: '2027-02-28T14:00:00Z',
    TrackingCode: 'B4',
    InstalmentAmount: 135,
    CTCAmount: 0,
    InstalmentStatus: 'A',
    LastUpdateDate: '2026-07-03T11:49:57Z'
  },
  {
    ClientNumber: 'MC-COV4895',
    ContractNumber: 'MC-COV4895',
    ContractSequence: 1053432320,
    InstalmentSequence: 9,
    InstalmentReferenceNumber: '10534323200009',
    InstalmentActionDate: '2027-03-31T14:00:00Z',
    TrackingCode: 'B4',
    InstalmentAmount: 135,
    CTCAmount: 0,
    InstalmentStatus: 'A',
    LastUpdateDate: '2026-07-03T11:49:57Z'
  },
  {
    ClientNumber: 'MC-COV4895',
    ContractNumber: 'MC-COV4895',
    ContractSequence: 1053432320,
    InstalmentSequence: 10,
    InstalmentReferenceNumber: '10534323200010',
    InstalmentActionDate: '2027-04-30T14:00:00Z',
    TrackingCode: 'B4',
    InstalmentAmount: 135,
    CTCAmount: 0,
    InstalmentStatus: 'A',
    LastUpdateDate: '2026-07-03T11:49:57Z'
  },
  {
    ClientNumber: 'MC-COV4895',
    ContractNumber: 'MC-COV4895',
    ContractSequence: 1053432320,
    InstalmentSequence: 11,
    InstalmentReferenceNumber: '10534323200011',
    InstalmentActionDate: '2027-05-31T14:00:00Z',
    TrackingCode: 'B4',
    InstalmentAmount: 135,
    CTCAmount: 0,
    InstalmentStatus: 'A',
    LastUpdateDate: '2026-07-03T11:49:57Z'
  },
  {
    ClientNumber: 'MC-COV4895',
    ContractNumber: 'MC-COV4895',
    ContractSequence: 1053432320,
    InstalmentSequence: 12,
    InstalmentReferenceNumber: '10534323200012',
    InstalmentActionDate: '2027-06-30T14:00:00Z',
    TrackingCode: 'B4',
    InstalmentAmount: 135,
    CTCAmount: 0,
    InstalmentStatus: 'A',
    LastUpdateDate: '2026-07-03T11:49:57Z'
  }
]
